import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'run_preference'

export default function RunPreferencePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value === 'beginner' ||
    value === 'novice' ||
    value === 'intermediate' ||
    value === 'advanced'
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'When do you prefer to run?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.runPreference.heading')}
      buttons={[
        {
          text: t('pages.onboarding.runPreference.options.earlyMorning'),
          value: 'earlyMorning',
        },
        {
          text: t('pages.onboarding.runPreference.options.lateMorning'),
          value: 'lateMorning',
        },
        {
          text: t('pages.onboarding.runPreference.options.afternoon'),
          value: 'afternoon',
        },
        {
          text: t('pages.onboarding.runPreference.options.evening'),
          value: 'evening',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
